class Animate {

    protected options;
    protected now;
    protected rafId;
    protected defaults = {
        draw: (progress) => {
            //this.log(progress)
        },
        onEnd: () => {

        },
        //type: 'linear',
        duration: 1000
    }

    constructor(params) {
        this.options = $.extend(this.defaults, params)
        this.start()
    }

    start() {
        this.now = performance.now()
        this.rafId = requestAnimationFrame(this.animate.bind(this))
    }

    linear(timeFraction) {
        return timeFraction;
    }

    quad(timeFraction) {
        return Math.pow(timeFraction, 2)
    }

    animate(time) {
        // timeFraction изменяется от 0 до 1
        let timeFraction = (time - this.now) / this.options.duration;
        if (timeFraction > 1) timeFraction = 1

        // вычисление текущего состояния анимации
        let progress = this.linear(timeFraction)

        // отрисовка
        this.options.draw(progress)

        if (timeFraction < 1) {
            this.rafId = requestAnimationFrame(this.animate.bind(this))
        } else {
            this.onAnimateEnd()
        }
    }

    onAnimateEnd() {
        this.options.onEnd();
    }

    cancel() {
        cancelAnimationFrame(this.rafId);
    }
}

export default Animate;
